(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__izziMinimalGate) return;
  window.__izziMinimalGate = true;
  const instances = new Map();
  function init(root) {
    root.querySelectorAll('[data-izzi-gate]').forEach(gate => {
      if (instances.has(gate)) return;
      const link = gate.querySelector('[data-izzi-enter]');
      let timer, zoomTimer, busy = false;
      const size = () => {
        const top = Math.max(0, gate.getBoundingClientRect().top + window.scrollY);
        gate.style.setProperty('--izzi-gate-top', `${top}px`);
      };
      const reset = () => {
        clearTimeout(timer); clearTimeout(zoomTimer); busy = false;
        gate.classList.remove('izzi-gate-opening', 'izzi-gate-leaving');
        link.removeAttribute('aria-busy');
      };
      const click = event => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !link.hasAttribute('href')) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        event.preventDefault();
        if (busy) return;
        busy = true; link.setAttribute('aria-busy', 'true');
        gate.classList.add('izzi-gate-opening');
        zoomTimer = setTimeout(() => gate.classList.add('izzi-gate-leaving'), 1000);
        timer = setTimeout(() => {
          if (window.Shopify?.designMode) reset();
          else window.location.assign(link.href);
        }, 1700);
      };
      link.addEventListener('click', click);
      window.addEventListener('resize', size);
      window.addEventListener('pageshow', reset);
      const observer = 'ResizeObserver' in window ? new ResizeObserver(size) : null;
      document.querySelectorAll('.shopify-section-group-header-group').forEach(el => observer?.observe(el));
      size();
      document.fonts?.ready.then(() => { if (gate.isConnected) size(); });
      instances.set(gate, () => {
        reset(); observer?.disconnect(); link.removeEventListener('click', click);
        window.removeEventListener('resize', size); window.removeEventListener('pageshow', reset);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => {init(event.target); window.dispatchEvent(new Event('resize'));});
  document.addEventListener('shopify:section:unload', event => {
    for (const [gate, cleanup] of instances) if (event.target.contains(gate)) {cleanup(); instances.delete(gate);}
  });
})();


(() => {
  const key = '__izziDoorControllerV2';
  if (window[key]) return;
  const instances = new Map();
  const mobile = matchMedia('(max-width: 749px)');
  window[key] = instances;
  const set = (el, values) => Object.entries(values).forEach(([k,v]) => el.style.setProperty(k, String(v), 'important'));
  function init(root) {
    if (mobile.matches) return;
    root.querySelectorAll('[data-izzi-doors]').forEach(banner => {
      if (instances.has(banner)) return;
      const media = banner.querySelector('.banner__media');
      const source = media && media.querySelector('img');
      // The first existing banner link remains the entry button.
      const firstLink = () => banner.querySelector('[data-izzi-enter]') || banner.querySelector('.banner__buttons a[href]');
      if (!source) return;
      const frame = document.createElement('div');
      frame.setAttribute('aria-hidden','true');
      frame.className = 'izzi-door-frame-v2';
      set(frame, {position:'absolute',display:'none','pointer-events':'none','z-index':'2',overflow:'hidden',margin:'0',padding:'0',border:'0',background:'transparent',perspective:'900px','box-sizing':'border-box'});
      banner.append(frame);
      let busy=false, timer, animations=[], disposed=false;
      function geometry() {
        if (!source.complete || !source.naturalWidth) return null;
        const mr=media.getBoundingClientRect(), br=banner.getBoundingClientRect();
        const iw=source.naturalWidth, ih=source.naturalHeight;
        if (!mr.width || !mr.height) return null;
        const d=banner.dataset;
        const x=Number(d.doorX)/100*iw, y=Number(d.doorY)/100*ih;
        const w=Number(d.doorW)/100*iw, h=Number(d.doorH)/100*ih;
        if (![x,y,w,h].every(Number.isFinite) || w<=0 || h<=0 || x<0 || y<0 || x+w>iw+.1 || y+h>ih+.1) return null;
        const cs=getComputedStyle(source);
        const scale=cs.objectFit==='contain' ? Math.min(mr.width/iw,mr.height/ih) : Math.max(mr.width/iw,mr.height/ih);
        const pos=cs.objectPosition.split(/\s+/);
        const part=(v, fallback) => v && v.endsWith('%') ? parseFloat(v)/100 : ({left:0,top:0,center:.5,right:1,bottom:1}[v] ?? fallback);
        return {x,y,w,h,iw,ih,scale,
          left:mr.left-br.left+(mr.width-iw*scale)*part(pos[0],.5)+x*scale,
          top:mr.top-br.top+(mr.height-ih*scale)*part(pos[1],.5)+y*scale};
      }
      function layout() {
        if (busy) return;
        const g=geometry();
        const debug=banner.dataset.doorDebug==='true';
        set(frame,{display:g && debug?'block':'none',background:'transparent',outline:debug?'2px solid #00ffcf':'none','outline-offset':'-2px'});
        if (g) set(frame,{left:g.left+'px',top:g.top+'px',width:g.w*g.scale+'px',height:g.h*g.scale+'px'});
      }
      function reset() {
        clearTimeout(timer); animations.forEach(a=>a.cancel()); animations=[];
        frame.replaceChildren();busy=false;
        firstLink()?.removeAttribute('aria-busy');
        layout();
      }
      function navigate(link) {
        if (disposed) return;
        if (window.Shopify && window.Shopify.designMode) reset();
        else {reset(); window.location.assign(link.href);}
      }
      async function click(e) {
        const link=firstLink();
        if (!link || !e.target.closest || e.target.closest('a')!==link || !link.hasAttribute('href')) return;
        if (e.defaultPrevented || (e.button!=null && e.button!==0) || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target==='_blank') return;
        const g=geometry();
        if (!g || matchMedia('(prefers-reduced-motion: reduce)').matches || !Element.prototype.animate) return;
        e.preventDefault();
        if (busy) return;
        busy=true;link.setAttribute('aria-busy','true');
        // Hard fallback: navigation remains available if loading/animation fails.
        timer=setTimeout(()=>navigate(link),3500);
        const leaves=[];
        const loads=[];
        for (let side=0;side<2;side++) {
          const leaf=document.createElement('div');
          set(leaf,{position:'absolute',display:'block',top:'0',left:(side*50)+'%',width:'50%',height:'100%',overflow:'hidden',margin:'0',padding:'0',border:'0',background:'transparent','max-width':'none','transform-origin':side?'right center':'left center','backface-visibility':'hidden'});
          const picture=document.createElement('img');
          picture.alt='';picture.draggable=false;
          set(picture,{position:'absolute',display:'block',width:g.iw*g.scale+'px',height:g.ih*g.scale+'px',left:-(g.x+side*g.w/2)*g.scale+'px',top:-g.y*g.scale+'px','max-width':'none','max-height':'none','min-width':'0',margin:'0',padding:'0',border:'0',transform:'none','object-fit':'fill',opacity:'1',visibility:'visible'});
          picture.src=source.currentSrc || source.src;
          loads.push(picture.decode ? picture.decode() : new Promise((resolve,reject)=>{if(picture.complete&&picture.naturalWidth)resolve();else{picture.onload=resolve;picture.onerror=reject;}}));
          leaf.append(picture);leaves.push(leaf);
        }
        try {await Promise.all(loads);} catch (_) {navigate(link);return;}
        if (disposed || !busy) return;
        clearTimeout(timer);
        // Only cover the original doors after both replacement images decoded.
        frame.replaceChildren(...leaves);
        set(frame,{display:'block',left:g.left+'px',top:g.top+'px',width:g.w*g.scale+'px',height:g.h*g.scale+'px',background:'radial-gradient(ellipse at 50% 90%, #27160e, #030201 70%)',outline:'none'});
        animations=leaves.map((leaf,i)=>leaf.animate([{transform:'rotateY(0deg)'},{transform:'rotateY('+(i?-86:86)+'deg)'}],{duration:1200,easing:'cubic-bezier(.4,0,.2,1)',fill:'forwards'}));
        timer=setTimeout(()=>navigate(link),1400);
      }
      const observer=new ResizeObserver(layout);observer.observe(media);
      source.addEventListener('load',layout);
      banner.addEventListener('click',click);
      window.addEventListener('pageshow',reset);
      layout();
      instances.set(banner,()=>{disposed=true;reset();observer.disconnect();source.removeEventListener('load',layout);banner.removeEventListener('click',click);window.removeEventListener('pageshow',reset);frame.remove();});
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  mobile.addEventListener('change', () => {
    if (mobile.matches) { for (const cleanup of instances.values()) cleanup(); instances.clear(); }
    else init(document);
  });
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{for(const [b,cleanup] of instances)if(e.target.contains(b)){cleanup();instances.delete(b);}});
})();


  } catch(e) { console.error(e); }
})();
})();
